<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'支付详情'"></div>
    <div class="query-wrapper">
      <div class="query-page" id="query-page">
        <h2>{{current_title}}</h2>
        <div :class="'icon icon-' + icon_state"></div>
        <h3>订单号：<span>{{ order }}</span></h3>
        <p class="wait-info" v-html="wait_info"></p>
        <a class="btn" @click="returnActivity()" href="javascript:;">确定</a>
      </div>
    </div>
  </div>

</template>
<script>
import { analysisParams, getRandomString } from '@/utils/utils';
import { wxPaymentApi } from '../api';

export default {
  components: {},
  data () {
    return {
      wait: 15,
      icon_state: '',
      order: '',
      role_id: '',
      token: '',
      sign: '',
      game_id: '',
      wait_info: '支付查询中<br/>请稍等',
      current_title: '等待支付结果完成中'
    };
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.forceLandscapeScreenHandle();
      this.onWindowSizeChanged();
      this.queryHash();
    });
  },
  computed: {},
  methods: {
    // 适配
    forceLandscapeScreenHandle () {
      if (document.activeElement.nodeName === 'INPUT') return; // 兼容安卓
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      var docEl = document.documentElement,
          fontH = (window.innerWidth > window.innerHeight) ? height : width;

      // const el = document.getElementById('app')
      const el = document.getElementById('query-page');
      let style = '';
      if (width < height) {
        // 竖版
        style = `transform:rotate(90deg);transform-origin:${width / 2}px center;width:${height}px;height:${width}px`;
        document.getElementsByTagName("body")[0].className="vertical-true";
      } else {
        // 横板        
        setTimeout(() => {
          document.documentElement.style.fontSize = (75 * fontH) / 750 + 'px';
          style = `transform:rotate(0deg);transform-origin:${width / 2}px center;width:${width}px;height:${height}px`;
          document.getElementsByTagName("body")[0].remove="vertical-true";
          if (el) el.style = style;
        }, 500);        
      }
      if (el) el.style = style;      
    },
    onWindowSizeChanged () {
      window.addEventListener('resize', this.forceLandscapeScreenHandle);
    },
    isReloadWindow (event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance && window.performance.navigation && window.performance.navigation.type === 2))
      );
    },
    // 查询信息
    queryHash() {
      const params = analysisParams(window.location.href);
      this.order = params.out_trade_no;
      console.log(params)
      if(params.role_id !== undefined) this.role_id = params.role_id;
      if(params.token !== undefined)   this.token = params.token;
      if(params.sign !== undefined)    this.sign = params.sign;
      if(params.game_id !== undefined)    this.game_id = params.game_id;
      this.orderLoop();
    },
    // 返回活动
    returnActivity() {
      if(!this.role_id && !this.token && !this.sign && !this.game_id) {
        window.location.href = '//h5.qingcigame.com/hjwq/kfhd_2/enter'+ getRandomString();
      } else {
        window.location.href = '//h5.qingcigame.com/hjwq/kfhd_2/enter'+ getRandomString() +'?' + '&role_id=' + this.role_id + '&token=' + this.token + '&sign=' + this.sign  + '&game_id=' + this.game_id;
      }
    },
    // 订单轮询
    orderLoop() {
      var _this = this;
      if (_this.wait > 0) {                
        _this.wxPayment();
        _this.wait--;
        _this.wait_info = "支付查询中<br/>请稍等 (" + _this.wait + 's)'
        setTimeout(function() {
          _this.orderLoop();
        }, 1500)
      }
    },
    // 订单查询
    wxPayment() {
      wxPaymentApi({trade_no: this.order})
        .then((response) => {
          this.current_title = response.message;
          if (Number(response.code) == 200) {
            this.wait = 0;
            this.icon_state = true;
            this.wait_info = '';
            return;
          }
          if (Number(response.code) != 200) {
            if(this.wait == 0) {
              this.current_title = '支付失败';
              this.icon_state = false;
              this.wait_info = '';
              return;
            }
          }
      });
    },
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/kfhd2/query/index.vue